import { render } from "./LotoX.vue?vue&type=template&id=6a2b72e9&scoped=true"
import script from "./LotoX.vue?vue&type=script&lang=js"
export * from "./LotoX.vue?vue&type=script&lang=js"

import "./LotoX.vue?vue&type=style&index=0&id=6a2b72e9&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2b72e9"]])

export default __exports__